import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faCalendarAlt, faPlusCircle, faArrowLeft} from '@fortawesome/fontawesome-free-solid';
import { PageTemplate, PageTitle, TopFixed, Container, TabsNavigation, CheckboxFilter, SearchFilter } from '../PageTemplate';
import { EventsActions } from '../../actions';
import { EventRow } from './';
import { ValidateDate } from '../../helper';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import './allEventsPage.scss';

class AllEventsPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            noFilter: true,
            filter: {
                open: false,
                wait: false,
                tmpClosed: false,
                finished: false,
            },
            filterDate: null,
            filterName: ""
        }

        this.noFilter = this.noFilter.bind(this);
        this.dateFilter = this.dateFilter.bind(this);
        this.nameFilter = this.nameFilter.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
    }

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(EventsActions.getAllEventsData());
    }

    onFilterChange(event) {
        const name = event.target.name;
        const value = !this.state.filter[name];   
        const data = {...this.state};     
        data.filter[name] = value;
        
        if(value) { // has filter
            data.noFilter = false; 
        } else if(!this.hasFilter(data)) {
            // no filter
            data.noFilter = true;
        }

        this.setState(data);
    }

    hasFilter(nextState) {
        if(Object.values(nextState.filter).includes(true)) return true;
        if(nextState.filterDate !== null) return true;
        if(nextState.filterName.length > 0) return true;

        return false;
    }

    noFilter() {
        const filter = {...this.state.filter};
        for(let p in filter) filter[p] = false;
        this.setState({filter: filter, filterDate: null, filterName: "", noFilter: true});
    }

    clearNameFilter() {
        const data = {...this.state};
        data.filterName = "";
        if(!this.hasFilter(data)) data.noFilter = true;
        
        this.setState(data);
    }

    nameFilter(event) {
        const value = event.target.value;
        const data = {...this.state};
        data.filterName = value;

        if(value.length > 0) data.noFilter = false;
        else if(!this.hasFilter(data)) data.noFilter = true;

        this.setState(data);
    }

    dateFilter(date) {
        const data = {...this.state};
        data.filterDate = date;
        
        if(date != null) data.noFilter = false
        else if(!this.hasFilter(data)) data.noFilter = true;
        
        this.setState(data);
    }

    filter(item) {
        if(!this.hasFilter(this.state)) return true;

        var ok = {
            filter: !Object.values(this.state.filter).includes(true), // if no filter return true
            date: false,
            name: false
        }

        const {filter, filterDate} = this.state;
        
        // status
        const status = ValidateDate.status(item.date, item.closed);
        if(filter[status]) ok.filter = true;
         
        // date 
        if(filterDate === null || filterDate.isSame(item.date.start, 'day') || filterDate.isSame(item.date.end, 'day')){
            ok.date = true;
        }
                
        // name 
        if(item.name.includes(this.state.filterName)) ok.name = true;

        return !Object.values(ok).includes(false);
    }

    sortByDate(list, asc = true) {
        return list.sort((left, right) => {
            // if no start date
            if(!left.date.start) return asc ? 1 : -1;
            if(!right.date.start) return asc ? -1 : 1;

            const leftStart = moment.utc(left.date.start);
            const rightStart = moment.utc(right.date.start);

            if(asc) return leftStart.diff(rightStart); // asc
            else return rightStart.diff(leftStart); // desc
        });
    }

    render() {
        const events = this.props.events &&  this.props.events.list;
        const {user} = this.props;
        const sumEvents = user && user.data && user.data.events && user.data.events.length;

        const rows = events && this.sortByDate(Object.values(events), false).map((item, index) => {
            if(this.filter(item)) return <EventRow key={index} data={item} />
        });

        return (
            <PageTemplate id="allEventsPage">
                <TopFixed>
                    <PageTitle>
                        <FontAwesomeIcon icon={faCalendarAlt} />&nbsp;אירועים
                    </PageTitle>
                    <TabsNavigation className={`${sumEvents === 0 && !rows ? ' hide ': ''}`}>
                        <div className="sortTitle">
                            סינון:&nbsp;
                        </div>
                        <CheckboxFilter checked={this.state.noFilter} name="noFilter" onChange={this.noFilter}>
                            ללא 
                        </CheckboxFilter>
                        <CheckboxFilter checked={this.state.filter.open} name="open" onChange={this.onFilterChange}>
                            <div className="eventStatus open"></div> פתוח עכשיו 
                        </CheckboxFilter>
                        <CheckboxFilter checked={this.state.filter.wait} name="wait" onChange={this.onFilterChange}>
                            <div className="eventStatus wait"></div> טרם נפתח
                        </CheckboxFilter>
                        <CheckboxFilter checked={this.state.filter.tmpClosed} name="tmpClosed" onChange={this.onFilterChange}>
                            <div className="eventStatus tmpClosed"></div> סגור זמנית
                        </CheckboxFilter>
                        <CheckboxFilter checked={this.state.filter.finished} name="finished" onChange={this.onFilterChange}>
                            <div className="eventStatus finished"></div> הסתיים
                        </CheckboxFilter>
                        <div className="datePickerFilter">
                            <DatePicker 
                                selected={this.state.filterDate} 
                                onChange={this.dateFilter} 
                                dateFormat="LL"
                                placeholderText="סינון לפי תאריך"
                                isClearable={true}
                                readOnly 
                            />
                        </div>
                        <SearchFilter name="filterByName" value={this.state.filterName} onChange={this.nameFilter} clear={this.clearNameFilter.bind(this)} placeholder="סינון לפי שם"/>
                    </TabsNavigation>
                    <div className={`columnsNames ${sumEvents === 0 && !rows ? 'hide': ''}`}>
                        <div className="eCol eStatus">מצב</div>
                        <div className="eCol eName">שם</div>
                        <div className="eCol eStartDate">זמן התחלה</div>
                        <div className="eCol eEndDate">זמן סיום</div>
                        <div className="eCol eImagesCount">מגנטים&nbsp;<small>(הגבלה / עותקים)</small></div>
                    </div>
                </TopFixed>
                <Container>
                    <div className="rows">
                        {rows}
                    </div>
                </Container>
                <Container>
                    <div id="placeholderEvent" className={`${sumEvents === 0 && !rows ? 'show': ''}`}>
                        <Link to="/events/create">
                            <div className="placeholderText">
                                עדיין אין לכם אירועים ביומן
                                <div className="formSubmitButton">
                                    <FontAwesomeIcon icon={faPlusCircle}/>&nbsp;יצירת אירוע
                                </div>
                            </div>
                        </Link>
                    </div>
                </Container>
            </PageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        user: state.userReducer
    }
}

const AllEventsPageWithRedux = connect(mapStateToProps)(AllEventsPage);

export {AllEventsPageWithRedux as AllEventsPage};


// WEBPACK FOOTER //
// ./src/components/AllEventsPage/AllEventsPage.jsx